import { toast } from "react-toastify";
import { documentAPI, panelAPI } from "../services/api";

export const useFinalReport = (panelId, panelTitle, user, onSuccess) => {
  const uploadFinalReport = async ({ reportName, reportSummary }) => {
    if (!reportName || !reportSummary) {
      toast.error("Please fill in all report details");
      return false;
    }

    try {
      // Create document in backend
      const report = {
        panelId: parseInt(panelId),
        name: reportName,
        description: reportSummary,
        type: "FINAL_REPORT",
        uploadedById: user?.id,
      };

      await documentAPI.uploadDocument(report);

      // Update panel status
      await panelAPI.updatePanel(panelId, {
        status: "PENDING_PUBLICATION",
        progress: 95,
      });

      const finalReport = {
        name: reportName,
        summary: reportSummary,
        uploadDate: new Date().toISOString().split("T")[0],
        uploadedBy: user?.name,
      };

      // Save notification for admin
      const adminNotifications = JSON.parse(
        localStorage.getItem("adminNotifications") || "[]"
      );
      adminNotifications.push({
        id: Date.now(),
        type: "FINAL_REPORT_SUBMITTED",
        panelId: parseInt(panelId),
        panelTitle: panelTitle,
        message: `Final report for "${panelTitle}" has been submitted and awaits publication approval.`,
        date: new Date().toISOString(),
        read: false,
      });
      localStorage.setItem(
        "adminNotifications",
        JSON.stringify(adminNotifications)
      );

      toast.success(
        "Final report uploaded successfully. Awaiting admin approval for publication."
      );

      // Mock alert
      alert(
        "📧 Email Notification Sent to Platform Admin:\n\nFinal report has been submitted for review and publication."
      );

      if (onSuccess) {
        onSuccess(finalReport);
      }

      return true;
    } catch (error) {
      console.error("Error uploading final report:", error);
      toast.error("Failed to upload final report");
      return false;
    }
  };

  return {
    uploadFinalReport,
  };
};
